import React, { useEffect, useState } from "react";
import ModalWindow from "../ModalWindow";
import OrderListItem from "./OrderListItem";
import OrderDetail from "./OrderDetail";
import { getOrders, deleteOrder } from "../../api";
import { orderNormalaise } from "../../config";

const OrdersList = () => {
  const [filter, setFilter] = useState("all");
  const [orders, setOrders] = useState(null);
  const [isDeleting, setDeleting] = useState(false);
  const curenTime = Math.floor(Date.now() / 1000);

  useEffect(() => {
    getUserOrders();
  }, []);

  const getUserOrders = async () => {
    const orders = await getOrders();

    setOrders(orderNormalaise(orders.data));
  };

  const removeOrder = async (id) => {
    await deleteOrder(id);

    const newOrdersList = orders.map((order) =>
      order.id === id
        ? {
            ...order,
            status: {
              value: "canceled",
              label: "Cancaled",
            },
          }
        : order
    );
    setOrders(newOrdersList);
  };

  return (
    <div className="order-list__wrapper">
      <div className="order-list__header">
        <div className="order-list__title">
          <div className="title">My Bookings</div>
          <div className="sub-title">
            View and manage your beauty appointments all in one place. Stay organized and keep track of your upcoming
            visits to beauty salons.
          </div>
        </div>
        <div className="step-navigation__wrapper">
          <div className="order-list__filter step-navigation">
            <button onClick={() => setFilter("all")} className={filter === "all" ? "step-btn active" : "step-btn"}>
              All
            </button>
            <button
              onClick={() => setFilter("upcoming")}
              className={filter === "upcoming" ? "step-btn active" : "step-btn"}
            >
              Upcoming
            </button>
            <button onClick={() => setFilter("past")} className={filter === "past" ? "step-btn active" : "step-btn"}>
              Past
            </button>
          </div>
        </div>
      </div>
      <div className="order-list">
        {orders?.map((order) => {
          let isDisplay = true;
          if (filter === "upcoming" && order.dateStartUnix <= curenTime) isDisplay = false;
          if (filter === "past" && order.dateStartUnix > curenTime) isDisplay = false;
          const isCancellationWithPenalty = order.dateStartUnix > curenTime - 10800; // 3h in second

          return (
            isDisplay && (
              <ModalWindow
                title={"Receipt"}
                btnContent={<OrderListItem order={order} />}
                btnClass="not-button"
                bgClass={isDeleting && (isCancellationWithPenalty ? "red-bg" : "line-bg")}
                header={!isDeleting}
              >
                <OrderDetail
                  order={order}
                  curenTime={curenTime}
                  removeOrder={() => removeOrder(order.id)}
                  isDeleting={isDeleting}
                  setDeleting={setDeleting}
                  withPenalty={isCancellationWithPenalty}
                />
              </ModalWindow>
            )
          );
        })}
      </div>
    </div>
  );
};

export default OrdersList;
